import React from 'react'
import maximsRunning from '../../../images/maxims_running.png'

const TheMaxims = () => {
	return (
		<div className='about-maxims section-container' style={{ margin: '32px 0px 64px' }}>
			<div className='ncss-col-sm-6 section-block' style={{ maxWidth: '610px', minWidth: '380px' }}>
				<h1 className='section-title'>The Maxims</h1>
				<p className='section-p'>
					Our Maxims represent our core values and beliefs and feature the fundamental behaviors that apply to all employees
					– no matter your role, location or level.
				</p>
			</div>
			<div className='ncss-col-sm-6 section-block'>
				<img
					src={maximsRunning}
					alt='Maxims Running'
					style={{
						borderRadius: '16px',
						minWidth: '380px',
						height: 'auto',
					}}
				/>
			</div>
		</div>
	)
}

export default TheMaxims



// WEBPACK FOOTER //
// ./src/containers/AboutPage/Maxims/TheMaxims.js